export default [
  {
    value: "None",
    label: "None",
  },
  {
    value: "AccuPOS",
    label: "AccuPOS",
  },
  {
    value: "Adyen",
    label: "Adyen",
  },
  {
    value: "Aldelo",
    label: "Aldelo",
  },
  {
    value: "Aloha",
    label: "Aloha",
  },
  {
    value: "Appetize",
    label: "Appetize",
  },
  {
    value: "Arryved",
    label: "Arryved",
  },
  {
    value: "Ascend",
    label: "Ascend",
  },
  {
    value: "Bindo",
    label: "Bindo",
  },
  {
    value: "BrewPOS",
    label: "BrewPOS",
  },
  {
    value: "Bypass",
    label: "Bypass",
  },
  {
    value: "Cake",
    label: "Cake",
  },
  {
    value: "Clover",
    label: "Clover",
  },
  {
    value: "Corebridge",
    label: "Corebridge",
  },
  {
    value: "Cortex",
    label: "Cortex",
  },
  {
    value: "Digital Dining",
    label: "Digital Dining",
  },
  {
    value: "Dinerware",
    label: "Dinerware",
  },
  {
    value: "Duet",
    label: "Duet",
  },
  {
    value: "Epos Now",
    label: "Epos Now",
  },
  {
    value: "Erply POS",
    label: "Erply POS",
  },
  {
    value: "EZee BurrP!",
    label: "EZee BurrP!",
  },
  {
    value: "Focus",
    label: "Focus",
  },
  {
    value: "Future POS",
    label: "Future POS",
  },
  {
    value: "Gingr",
    label: "Gingr",
  },
  {
    value: "Harbortouch",
    label: "Harbortouch",
  },
  {
    value: "Heartland",
    label: "Heartland",
  },
  {
    value: "Housecall Pro",
    label: "Housecall Pro",
  },
  {
    value: "HRPOS",
    label: "HRPOS",
  },
  {
    value: "Intuit Quickbooks",
    label: "Intuit Quickbooks",
  },
  {
    value: "JCR Systems",
    label: "JCR Systems",
  },
  {
    value: "Lavu POS",
    label: "Lavu POS",
  },
  {
    value: "Lightspeed",
    label: "Lightspeed",
  },
  {
    value: "LINGA",
    label: "LINGA",
  },
  {
    value: "Loyverse",
    label: "Loyverse",
  },
  {
    value: "Maitre’D",
    label: "Maitre’D",
  },

  {
    value: "Micros",
    label: "Micros",
  },
  {
    value: "Micro Sales",
    label: "Micro Sales",
  },
  {
    value: "Mitchell 1",
    label: "Mitchell 1",
  },
  {
    value: "NCR",
    label: "NCR",
  },
  {
    value: "NCR Silver",
    label: "NCR Silver",
  },
  {
    value: "Nobly",
    label: "Nobly",
  },
  {
    value: "Oracle/Micros",
    label: "Oracle/Micros",
  },
  {
    value: "Other",
    label: "Other",
  },
  {
    value: "Positouch",
    label: "Positouch",
  },
  {
    value: "Poynt",
    label: "Poynt",
  },
  {
    value: "Rain",
    label: "Rain",
  },
  {
    value: "Restaurant Manager",
    label: "Restaurant Manager",
  },
  {
    value: "Revel",
    label: "Revel",
  },
  {
    value: "Rezku",
    label: "Rezku",
  },
  {
    value: "R Power",
    label: "R Power",
  },
  {
    value: "Shopify",
    label: "Shopify",
  },
  {
    value: "Shopkeep",
    label: "Shopkeep",
  },
  {
    value: "Silverware",
    label: "Silverware",
  },
  {
    value: "Skytab",
    label: "Skytab",
  },
  {
    value: "SmartTab",
    label: "SmartTab",
  },
  {
    value: "SpotOn",
    label: "SpotOn",
  },
  {
    value: "Square",
    label: "Square",
  },
  {
    value: "Stripe",
    label: "Stripe",
  },
  {
    value: "Talech POS",
    label: "Talech POS",
  },
  {
    value: "Toast",
    label: "Toast",
  },
  {
    value: "Touch Bistro",
    label: "Touch Bistro",
  },
  {
    value: "Upserve",
    label: "Upserve",
  },
  {
    value: "Vend",
    label: "Vend",
  },
];
